import { useState } from "react"
import { Flex } from "@chakra-ui/react"
import dynamic from "next/dynamic"
import Header from "./headerTct2025alt"
import Footer from "components/footer/footerStandard"
import CrfErrorBoundary from "components/error/CrfErrorBoundary"
import SeoMetaFields from "components/header/seoMetaFields"
import SocialMediaSection from "components/ui/SocialMediaSection"
import PageContent from "components/layout/pageContent"
import FloatingChatbot from "components/ai/FloatingChatbot"

// Dynamic import - only loaded when rendered
const AppLayout = dynamic(() => import("components/layouts/app/appLayout"))

export default function LayoutTct2025(props) {
    // an ad set on the page overrides the global site ad
    const resolvedAd = props.pageAd ? props.pageAd : props.site?.meeting?.ad
    const ad = !props.hideAd ? resolvedAd : null
    // where to place the ad within the content blocks (0 = above the first block)
    const adPositionIndex = props.site?.meeting?.adPosition ?? 1

    return (
        <LayoutWrapper {...props}>
            <CrfErrorBoundary>
                <PageContent
                    page={props.page}
                    matrix={props.matrix}
                    site={props.site}
                    user={props.user}
                    colorMode={props.colorMode}
                    channels={props.channels}
                    sessionTypes={props.sessionTypes}
                    sessionId={props.sessionId}
                    presentationId={props.presentationId}
                    facetsConfig={props.facetsConfig}
                    craftSiteId={props.craftSiteId}
                    ad={ad}
                    adPositionIndex={adPositionIndex}
                    showPageHeader={false}
                >
                    {props.children}
                </PageContent>
            </CrfErrorBoundary>
        </LayoutWrapper>
    )
}

function LayoutWrapper({ children, ...props }) {
    // handles "app" layout variant
    if (props.layoutVariant === "app") return <AppLayout {...props}>{children}</AppLayout>

    const _hideSocialFooter = props.hideSocialFooter || props.site?.meeting?.hideSocialFooter || false

    return (
        <Flex direction="column" minHeight="100vh" bg="color5" className={props.className} {...props.bgStyles}>
            <Header site={props.site} hideNav={props.hideNav} />

            <Flex className="pageBody" flexGrow={1} direction="column">
                <SeoMetaFields page={props.page} />
                {children}
            </Flex>

            {!_hideSocialFooter && props.socialFooterText && (
                <SocialMediaSection text={props.socialFooterText} className="socialFooter" textAlign="center" />
            )}

            <FloatingChatbot site={props.site} />

            <Footer />
        </Flex>
    )
}
